import {apiCall} from "../../../common/apiActionHandler";
import axios from "axios";
import * as FileSaver from "file-saver";
import moment from "moment";

export const downloadClientData = (id, client_name) => async (dispatch, getState) => {
    const config = {
        url: `/api/clients/${id}/export_data`,
        responseType: 'blob'
    };

    apiCall(`Downloading ${client_name} data`, config, async config => {
        const response = await axios.request(config);
        const blob = new Blob([response.data], {
            type: 'application/zip',
        });
        FileSaver.saveAs(blob, `${client_name}-data-${moment().format('YYYYMMDD_HHmmss')}.zip`);
    }, dispatch, getState);
};

export const downloadClientImages = (id, client_name) => async (dispatch, getState) => {
    const config = {
        url: `/api/clients/${id}/export_images`,
        responseType: 'blob'
    };

    apiCall(`Downloading ${client_name} images`, config, async config => {
        const response = await axios.request(config);
        const blob = new Blob([response.data], {
            type: 'application/zip',
        });
        FileSaver.saveAs(blob, `${client_name}-data-${moment().format('YYYYMMDD_HHmmss')}.zip`);
    }, dispatch, getState);
};